/* eslint-disable camelcase */
import { Component } from 'react';
import { connect } from 'react-redux';
import { Row, Col, Card } from 'react-bootstrap';
import SellItPerformances from './sell-it/sell-it-performances';
import StockItPerformances from './stock-it';

import expand from '../../assets/img/performances/Expand@2x.png';
import collapse from '../../assets/img/performances/Collapse@2x.png';

class ObjectivePerformances extends Component {
  render() {
    const {
      performances, pages, panelRefs, openPanels, handleClick
    } = this.props;
    const panelContent = {
      stock_it: <StockItPerformances performances={performances.stock_it} />,
      sell_it: <SellItPerformances performances={performances.sell_it} />,
      ngp: <SellItPerformances performances={performances.ngp} />
    };

    return (
      <Row>
        <Col lg={12}>
          {Object.entries(pages).map(([key, label]) =>
            (
              <div
                key={key}
                ref={(element) => { panelRefs[key] = element; }}
              >
                <Card>
                  <Card.Header>
                    <div id={key} className="card-title" onClick={() => handleClick(key)}>
                      {label}
                      <img className="panel-toggle" src={openPanels.includes(key) ? collapse : expand} />
                    </div>
                  </Card.Header>
                  { openPanels.includes(key) && (
                    <Card.Body>
                      {panelContent[key]}
                    </Card.Body>
                  )}
                </Card>
              </div>
            ))}
        </Col>
      </Row>
    );
  }
}

const mapStateToProps = state => ({
  performances: state.stores.performances,
});

export default connect(mapStateToProps)(ObjectivePerformances);
